module.exports = __webpack_public_path__ + "static/media/XLine.4c55caf9.png";